module.exports = __webpack_public_path__ + "assets/96012e7130722541e8790f91eafd6151.png";